import type { MouseEventHandler } from 'react';

import { motion } from 'motion/react';
import styled, { css } from 'styled-components';
import themeSpacing from 'styles/config/spacing';
import hexToRgb from 'styles/functions/hexToRgb';

export type ScrollIndicatorPosition = 'top' | 'bottom';

export const ScrollIndicator = styled(motion.div)<{
  $position: ScrollIndicatorPosition;
  $iconOpacity?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
}>`
  ${({ $position }) => ($position === 'top' ? 'top' : 'bottom')}: 0;

  pointer-events: ${({ onClick }) => (onClick ? 'auto' : 'none')};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  position: absolute;
  z-index: 11;

  overflow: hidden;
  display: flex;
  justify-content: center;

  width: 100%;
  height: ${themeSpacing.md1};

  ${({ $position }) =>
    $position === 'top'
      ? css`
          padding-top: ${themeSpacing.xs1};
        `
      : css`
          align-items: flex-end;
          padding-bottom: ${themeSpacing.xs1};
        `};

  background: linear-gradient(
    ${({ $position: position, theme }) =>
      hexToRgb(
        theme.activeColorScheme.colors.backgroundInverse,
        position === 'top' ? 1 : 0,
      )}
      ${({ $position: position }) => (position === 'top' ? '50%' : '0%')},
    ${({ $position: position, theme }) =>
      hexToRgb(
        theme.activeColorScheme.colors.backgroundInverse,
        position === 'bottom' ? 1 : 0,
      )}
      ${({ $position: position }) => (position === 'top' ? '100%' : '50%')}
  );

  svg {
    opacity: ${({ $iconOpacity = 1 }) => $iconOpacity};
  }
`;
